module.exports = "<button class=\"btn btn-icon btn-icon-light btn-application-help\"><i class=\"spark-icon spark-icon-question-circle\"></i></button>";